export const getAvailableMenuEntries = (menuEntries, routes, hasPermissions) =>
  menuEntries.filter(menuEntry =>
    routes.find(route => (
      (route.path === menuEntry.route) &&
      (hasPermissions(route.permissions))
    ))
  )
